import Button from '@redbubble/design-system/src/Button';
import * as constants from '@redbubble/design-system/src/constants';
import RulerIcon from '@redbubble/design-system/src/Icons/Ruler';
import { useIntl } from '@redbubble/next/intl';
import { ModalSize, useOpenModal } from '@redbubble/next/modals';
import { FC } from 'react';
import { messages } from './messages';
import {
  SizeGuideModalContent,
  SizeGuideModalContentLoadingState,
} from './SizeGuideModalContent';
import type { SizeGuideData } from './types';
import { Gender, MeasurementUnit } from './types';

export interface SizeGuideButtonProps {
  productTypeId: string;
  workId: number;
  onClick?: () => void;
  sizeGuideData?: SizeGuideData;
  initialGender?: Gender;
  initialMeasurementUnit?: MeasurementUnit;
}

export const SizeGuideButton: FC<SizeGuideButtonProps> = ({
  productTypeId,
  workId,
  onClick,
  sizeGuideData,
  initialGender,
  initialMeasurementUnit,
}) => {
  const intl = useIntl();
  const openModal = useOpenModal();

  const handleClick = () => {
    onClick?.();
    openModal({
      accessibleTitle: intl.formatMessage(messages.modalAccessibleTitle),
      content: sizeGuideData ? (
        <SizeGuideModalContent
          sizeGuideData={sizeGuideData}
          initialGender={initialGender}
          initialMeasurementUnit={initialMeasurementUnit}
          productTypeId={productTypeId}
        />
      ) : (
        <SizeGuideModalContentLoadingState />
      ),
      size: ModalSize.Large,
    });
  };

  return (
    <Button
      intent={constants.PRIMARY}
      size={constants.SMALL}
      iconBefore={<RulerIcon />}
      onClick={handleClick}
    >
      {intl.formatMessage(messages.openButtonText)}
    </Button>
  );
};
